export default {"src":"/uk/_next/static/media/spot-combine-pensions.f7a02d99.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};